var React = require('react');

function Round3 (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#fff","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M15.98 43.55L75.26 8.92M30.71 52.28l59.27-34.63M15.5 43.55v68.67M30.5 52.28v68.73M2.25 35.71l44 25.47","strokeWidth":"2","key":0}),React.createElement("path",{"strokeWidth":"1.5","d":"M105.52 26.55L61.505 1.29 1.5 35.71v68.85l44.75 25.42v-68.8z","key":1})]));
}

Round3.defaultProps = {"viewBox":"0 0 123 140"};

module.exports = Round3;

Round3.default = Round3;
